module.exports = __webpack_public_path__ + "static/media/startup-web.657c83fc.png";